import { Controller } from "@api/config";
import type { IRequestConfig } from "@api/config";

import { IUpdateTariffDataRequest } from "./request.types";
import { TGetTariffDataResponse } from "./response.types";

class TariffController extends Controller {
	public constructor() {
		super({ requestUrl: "models/" });
	}

	/**@GET USER BALANCE */
	public async getModelBalanceAsync({ token }: IRequestConfig) {
		return this.get<{ balance: number }>("base", "balance", { token });
	}

	/**@GET MODEL TARIFF*/
	public async getTariffDataAsync({ token }: IRequestConfig) {
		return this.get<TGetTariffDataResponse>("base", "tariff", { token });
	}

	/**@PUT UPDATE MODEL TARIFF */
	public async updateTariffDataAsync({ token, data }: IUpdateTariffDataRequest) {
		return this.put<TGetTariffDataResponse>("tariff", { ...data }, { token });
	}
}

export const tariffAPI = new TariffController();
